// extracted by mini-css-extract-plugin
export var addToCartButton = "_nz-b";
export var arrowButtonContainer = "_nz-9";
export var arrowButtonIcon = "_nz-a";
export var carouselArrowButton = "_nz-6";
export var carouselElementContainer = "_nz-1";
export var galleryThumbnail = "_nz-d";
export var galleryThumbnailImage = "_nz-e";
export var left = "_nz-7";
export var productDisplayCarouselContainer = "_nz-0";
export var productTileContainer = "_nz-2";
export var productTileImage = "_nz-4";
export var productTileImageContainer = "_nz-3";
export var productTileTitle = "_nz-5";
export var right = "_nz-8";
export var sliderOverflow = "_nz-c";